import React, { useState, useEffect, useLoca } from 'react';
import '../../css/login_style.css';
import { useNavigate } from 'react-router-dom';
import logo from "../../assets/images/logo-123cloud.svg";
import bg from "../../assets/images/bg-login.jpg";
import "./resetpassword.css";

import { register } from '../../components/Service/UserService';
import { toast, ToastContainer } from "react-toastify";

import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import { Validatedata } from './ValidateData/Validatedata';
import ReCAPTCHA from "react-google-recaptcha"; // Import thư viện reCAPTCHA
import { useParams, useLocation } from 'react-router-dom';
import { motion } from "framer-motion";

const url = process.env.REACT_APP_IMAGE_LOGO;

const Register = () => {
    const navi = useNavigate();
    const [captchaValue, setCaptchaValue] = useState(null);
    const [loading, setLoading] = useState(false);
    const [des, setDes] = useState(null);
    const [dessub1, setDessub1] = useState(null);
    const [dessub2, setDessub2] = useState(null);

    // const { coupon2000, student } = useParams();
    const location = useLocation();
    const [coupon2000, setcoupon2000] = useState(0);
    const [placeholder, setPlaceholder] = useState(null);



    // const getUtm_Source = () => {
    //     return coupon2000 ? 1 : 0;
    // };
    // useEffect(() => {
    //     if (student) {
    //         setDes("Sinh viên"); 
    //     } else if (coupon2000) {
    //         setDes("Bắt đầu dùng thử miễn phí với khoản tín dụng 2 triệu trong 30 ngày.");
    //     }
    // }, [coupon2000, student]);
    useEffect(() => {
        if (location.pathname === "/register/student") {
            setDes("Sinh Viên thì đừng bỏ lỡ ");
            setDessub1("6 tháng");
            setDessub2(" sử dụng Cloud Server MIỄN PHÍ")
            setcoupon2000(2);

        } else if (location.pathname === "/register/coupon") {
            setDes("Bắt đầu dùng thử miễn phí với ");
            setDessub1("2.000.000");
            setDessub2(" trong 30 ngày.")
            setcoupon2000(1);
        }
        else {
            setDes("Đăng ký tài khoản");
            setcoupon2000(0);

        }
    }, [location]);

    console.log("des", des)

    const getPlaceHolder = () => {


    }

    const [formData, setFormData] = useState({
        email: '',
        password: '',
        passwordConfirm: '',
        username: '',
        phone: ''
    });
    const [errors, setErrors] = useState({
        email: '',
        password: '',
        passwordConfirm: ''
    });
    const [submitAttempted, setSubmitAttempted] = useState(false);

    useEffect(() => {
        if (window.location.pathname == "/register/student") {
            setPlaceholder("sinhvien@abc.edu.vn")
        }
        document.body.style.backgroundImage = `url(${bg})`;
        return () => {
            document.body.style.backgroundImage = '';
        };
    }, []);
    console.log("Current pathname:", window.location.pathname);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });

        if (name === "email") {


            if (Validatedata.validateEmail(value)) {
                setErrors((prevErrors) => ({ ...prevErrors, email: '' }));


            } else {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    email: 'Email không hợp lệ.'
                }));
            }
        }
        if (name === "password" && Validatedata.isStrongPassword(value)) {
            setErrors((prevErrors) => ({ ...prevErrors, password: '' }));
        }
        if (name === "passwordConfirm" && value === formData.password) {
            setErrors((prevErrors) => ({ ...prevErrors, passwordConfirm: '' }));
        }
        if (name === "username" && !/^[a-zA-ZÀ-ỹ\s]+$/.test(value)) {
            setErrors((prevErrors) => ({ ...prevErrors, username: 'Tên không được chứa ký tự đặc biệt hoặc số.' }));
        } else if (name === "username") {
            setErrors((prevErrors) => ({ ...prevErrors, username: '' }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});
        setSubmitAttempted(true);
        const { username, phone, email, password, passwordConfirm } = formData;
        let hasError = false;
        let newErrors = {};

        if (window.location.pathname === "/register/student") {
            console.log("Kiểm tra email sinh viên...");

            const eduEmailRegex = /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9.-]+\.)?edu(\.vn)?$/;
            if (!eduEmailRegex.test(email)) {
                setErrors((prevErrors) => ({ ...prevErrors, email: 'Email phải có đuôi .edu.vn' }));
                hasError = true;
            }
        }

        if (!Validatedata.validateEmail(email)) {
            setErrors((prevErrors) => ({ ...prevErrors, email: 'Địa chỉ email không hợp lệ!' }));
            hasError = true;
        }
        if (!Validatedata.isStrongPassword(password)) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                password: 'Mật khẩu cần ít nhất 12 ký tự, bao gồm chữ hoa, chữ thường, chữ số và ký tự đặc biệt.',
            }));
            hasError = true;
        }
        if (!Validatedata.validatePhoneNumber(phone)) {
            setErrors((prevErrors) => ({ ...prevErrors, phone: 'Số Điện Thoại Không Hợp Lệ.' }));
            hasError = true;
        }
        if (password !== passwordConfirm) {
            setErrors((prevErrors) => ({ ...prevErrors, passwordConfirm: 'Mật Khẩu Không Giống Nhau' }));
            hasError = true;
        }
        if (!captchaValue) {
            setErrors((prevErrors) => ({ ...prevErrors, captcha: 'Vui lòng xác nhận bạn không phải là robot.' }));
            hasError = true;
        }


        if (!hasError) {
            setLoading(true);
            try {
                const res = await register(username, phone, email, password, passwordConfirm, coupon2000);

                Cookies.set('activationMessage', 'Kiểm tra email để kích hoạt tài khoản', {
                    expires: 1, path: '/', secure: true,
                    sameSite: 'None'
                });
                Cookies.set('email', email, {
                    expires: 1, path: '/', secure: true,
                    sameSite: 'None'
                });

                toast.success("Đăng ký thành công!");
                navi('/');

            } catch (error) {
                const errorMessage = error.response?.data?.message || 'Có lỗi xảy ra';
                setErrors((prevErrors) => ({ ...prevErrors, general: errorMessage }));
            } finally {
                setLoading(false);
            }
        }

    };

    useEffect(() => {
    }, [errors]);
    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
        setErrors((prevErrors) => ({ ...prevErrors, captcha: '' }));
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}  // Bắt đầu từ trong suốt
            animate={{ opacity: 1 }}  // Dần hiện ra
        >
            <div className="app flex-row align-items-center">
                {
                    loading && (
                        <div className="spinner-overlay">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>

                        </div>
                    )
                }
                <div className="container">
                    <div className="loginbackground">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row justify-content">
                                    <div className="col-md-6">
                                        <section className="ftco-section login">
                                            <div className="container">
                                                <div className="row justify-content-center">
                                                    <div className="col-md-12">
                                                        <div className="d-md-flex box-login">
                                                            <div className="col-md-12">
                                                                <div className="login-right">
                                                                    <div className="logo-main">
                                                                        <img
                                                                            style={{
                                                                                backgroundColor: "white",
                                                                                padding: "8px",
                                                                                marginTop: "-5px",
                                                                                width: "30%"
                                                                            }}
                                                                            className="navbar-brand-full logo-header"
                                                                            src={`${process.env.REACT_APP_IMAGE_LOGO}/images/logo.svg`}
                                                                            alt="TIDADIGI"
                                                                        />                                                                </div>
                                                                    <h1 className="login-title" style={{ textAlign: "center" }}>{des} <span style={{ color: "red" }}>{dessub1}</span> <span>{dessub2}</span></h1>
                                                                    {coupon2000 == 1 && <h1 className="login-title" style={{ textAlign: "center", fontSize: "14px" }}>Mã khuyến mãi: TIDADIGI2000K</h1>}
                                                                    <form method="POST" onSubmit={handleSubmit} id="form_register">
                                                                        <div className="form-group mb-3">
                                                                            <label className="label-login" htmlFor="email">Email</label>
                                                                            <input
                                                                                id="email"
                                                                                type="email"
                                                                                className="form-control-login"
                                                                                name="email"
                                                                                value={formData.email}
                                                                                onChange={handleChange}
                                                                                required


                                                                                placeholder={placeholder}
                                                                                autoComplete="new-email"
                                                                            />
                                                                            {submitAttempted && errors.email && <span style={{ color: 'red' }}>{errors.email}</span>}
                                                                            {submitAttempted && errors.general && <div style={{ color: 'red' }}>{errors.general}</div>}

                                                                        </div>
                                                                        <div className="form-group mb-3">
                                                                            <label className="label-login" htmlFor="password">Mật khẩu</label>
                                                                            <input
                                                                                id="password"
                                                                                type="password"
                                                                                className="form-control-login"
                                                                                name="password"
                                                                                value={formData.password}
                                                                                onChange={handleChange}
                                                                                required
                                                                                autoComplete="password"
                                                                            />
                                                                            {submitAttempted && errors.password && <span style={{ color: 'red' }}>{errors.password}</span>}
                                                                        </div>
                                                                        <div className="form-group mb-3">
                                                                            <label className="label-login" htmlFor="password-confirm">Xác nhận mật khẩu</label>
                                                                            <input
                                                                                id="password-confirm"
                                                                                type="password"
                                                                                className="form-control-login"
                                                                                name="passwordConfirm"
                                                                                value={formData.passwordConfirm}
                                                                                onChange={handleChange}
                                                                                required
                                                                                autoComplete="password-confirm"

                                                                            />
                                                                            {submitAttempted && errors.passwordConfirm && <span style={{ color: 'red' }}>{errors.passwordConfirm}</span>}
                                                                        </div>
                                                                        <div className="form-group mb-3">
                                                                            <label className="label-login" htmlFor="name">Họ và Tên</label>
                                                                            <input
                                                                                id="name"
                                                                                type="text"
                                                                                className="form-control-login"
                                                                                name="username"
                                                                                value={formData.username}
                                                                                onChange={handleChange}
                                                                                required
                                                                            />
                                                                        </div>

                                                                        <div className="form-group mb-3">
                                                                            <label className="label-login" htmlFor="name">Số Điện Thoại</label>
                                                                            <input
                                                                                id="phone"
                                                                                type="text"
                                                                                className="form-control-login"
                                                                                name="phone"
                                                                                value={formData.phone}
                                                                                onChange={handleChange}
                                                                                required
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            className="form-group mb-3"
                                                                            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                                                                        >
                                                                            <ReCAPTCHA
                                                                                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                                                                onChange={handleCaptchaChange}
                                                                            />
                                                                        </div>

                                                                        <div>
                                                                            <span
                                                                                className="custom-policy-text"
                                                                                style={{ fontSize: "13px", color: "#929292" }}
                                                                            >
                                                                                <p>
                                                                                    * Khi click nút đăng ký, nghĩa là bạn đã đồng ý với
                                                                                    <a
                                                                                        style={{ textDecoration: "none", padding: "5px" }}
                                                                                        href={`${url}/chinh-sach-bao-mat`}
                                                                                        target="_blank"
                                                                                    >
                                                                                        chính sách bảo mật
                                                                                    </a>
                                                                                    và
                                                                                    <a
                                                                                        style={{ textDecoration: "none", padding: "5px" }}
                                                                                        href={`${url}/dieu-khoan-su-dung-dich-vu`}
                                                                                        target="_blank"
                                                                                    >
                                                                                        thỏa thuận sử dụng
                                                                                    </a>
                                                                                    của chúng tôi.
                                                                                </p>
                                                                            </span>
                                                                        </div>
                                                                        {submitAttempted && errors.phone && <span style={{ color: 'red' }}>{errors.phone}</span>}

                                                                        <div className="form-group">
                                                                            <button
                                                                                style={{ background: "#040053", color: "white" }}
                                                                                type="submit"
                                                                                className="form-control-btn btn btn-primary submit px-3"
                                                                                disabled={loading}>
                                                                                {loading ? 'Đang xử lý...' : 'Đăng ký ngay'}
                                                                            </button>
                                                                        </div>
                                                                        <div className="login-bottom">
                                                                            <span style={{ color: "#333" }}>
                                                                                Bạn đã có tài khoản?  <a type='button' href="/" style={{ textDecoration: "none" }}>Đăng nhập</a>
                                                                            </span>
                                                                        </div>
                                                                    </form>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            </div >    </motion.div>
    );
};

export default Register;
